import { render, staticRenderFns } from "./Termuse.vue?vue&type=template&id=f840a51e&"
import script from "./Termuse.vue?vue&type=script&lang=js&"
export * from "./Termuse.vue?vue&type=script&lang=js&"
import style0 from "./Termuse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports